const actions = {
    // get bankFeedList - for array of options, non-paginated
    BANK_FEED_READ_ALL_REQUEST: 'BANK_FEED_READ_ALL_REQUEST',
    BANK_FEED_READ_ALL_SUCCESS: 'BANK_FEED_READ_ALL_SUCCESS',
    BANK_FEED_READ_ALL_ERROR: 'BANK_FEED_READ_ALL_ERROR',

    // bankFeed actions - sync, connect, disconnect
    BANK_FEED_CONNECT_REQUEST: 'BANK_FEED_CONNECT_REQUEST',
    BANK_FEED_CONNECT_SUCCESS: 'BANK_FEED_CONNECT_SUCCESS',
    BANK_FEED_CONNECT_ERROR: 'BANK_FEED_CONNECT_ERROR',

    BANK_FEED_DISCONNECT_REQUEST: 'BANK_FEED_DISCONNECT_REQUEST',
    BANK_FEED_DISCONNECT_SUCCESS: 'BANK_FEED_DISCONNECT_SUCCESS',
    BANK_FEED_DISCONNECT_ERROR: 'BANK_FEED_DISCONNECT_ERROR',

    BANK_FEED_SYNC_REQUEST: 'BANK_FEED_SYNC_REQUEST',
    BANK_FEED_SYNC_SUCCESS: 'BANK_FEED_SYNC_SUCCESS',
    BANK_FEED_SYNC_ERROR: 'BANK_FEED_SYNC_ERROR',
    // -----------------------------

    // bankFeed actions - account mapping after connect success
    BANK_FEED_MAP_ACCOUNTS_REQUEST: 'BANK_FEED_MAP_ACCOUNTS_REQUEST',
    BANK_FEED_MAP_ACCOUNTS_SUCCESS: 'BANK_FEED_MAP_ACCOUNTS_SUCCESS',
    BANK_FEED_MAP_ACCOUNTS_ERROR: 'BANK_FEED_MAP_ACCOUNTS_ERROR',

    SET_ACC_MAPPING_MODAL_OPEN: 'SET_ACC_MAPPING_MODAL_OPEN',
    SET_PENDING_CHECKER_MODAL_OPEN: 'SET_PENDING_CHECKER_MODAL_OPEN',

    // get bankFeedTransactionList - for array of options, paginated
    BANK_FEED_TRANSACTION_READ_ALL_REQUEST: 'BANK_FEED_TRANSACTION_READ_ALL_REQUEST',
    BANK_FEED_TRANSACTION_READ_ALL_SUCCESS: 'BANK_FEED_TRANSACTION_READ_ALL_SUCCESS',
    BANK_FEED_TRANSACTION_READ_ALL_ERROR: 'BANK_FEED_TRANSACTION_READ_ALL_ERROR',

    // delete and bulk delete bank feed transaction(s)
    BANK_FEED_TRANSACTION_DELETE_REQUEST: 'BANK_FEED_TRANSACTION_DELETE_REQUEST',
    BANK_FEED_TRANSACTION_DELETE_SUCCESS: 'BANK_FEED_TRANSACTION_DELETE_SUCCESS',
    BANK_FEED_TRANSACTION_DELETE_ERROR: 'BANK_FEED_TRANSACTION_DELETE_ERROR',

    BANK_FEED_TRANSACTION_BULK_DELETE_REQUEST: 'BANK_FEED_TRANSACTION_BULK_DELETE_REQUEST',
    BANK_FEED_TRANSACTION_BULK_DELETE_SUCCESS: 'BANK_FEED_TRANSACTION_BULK_DELETE_SUCCESS',
    BANK_FEED_TRANSACTION_BULK_DELETE_ERROR: 'BANK_FEED_TRANSACTION_BULK_DELETE_ERROR',
    // -----------------------------

    // get bank feed reconciliation - requires date range to start
    BANK_FEED_SMART_RECON_REQUEST: 'BANK_FEED_SMART_RECON_REQUEST',
    BANK_FEED_SMART_RECON_SUCCESS: 'BANK_FEED_SMART_RECON_SUCCESS',
    BANK_FEED_SMART_RECON_ERROR: 'BANK_FEED_SMART_RECON_ERROR',

    // BANK FEED CONNECT
    readAllBankFeeds: () => ({
        type: actions.BANK_FEED_READ_ALL_REQUEST,
    }),

    connectBankFeed: bankFeedId => ({
        type: actions.BANK_FEED_CONNECT_REQUEST,
        bankFeedId,
    }),

    disconnectBankFeed: () => ({
        type: actions.BANK_FEED_DISCONNECT_REQUEST,
    }),

    syncBankFeed: bankFeedId => ({
        type: actions.BANK_FEED_SYNC_REQUEST,
        bankFeedId,
    }),

    mapBankFeedAccounts: (bankFeedId, request) => ({
        type: actions.BANK_FEED_MAP_ACCOUNTS_REQUEST,
        bankFeedId,
        request,
    }),

    setAccMappingModalOpen: isOpen => ({
        type: actions.SET_ACC_MAPPING_MODAL_OPEN,
        isOpen,
    }),

    setPendingCheckerModalOpen: isOpen => ({
        type: actions.SET_PENDING_CHECKER_MODAL_OPEN,
        isOpen,
    }),

    // BANK FEED TRANSACTIONS
    readAllBankFeedTransactions: (bank_feed_id, account_id, payload) => ({
        type: actions.BANK_FEED_TRANSACTION_READ_ALL_REQUEST,
        bank_feed_id,
        account_id,
        payload,
    }),

    deleteBankFeedTransaction: (bank_feed_id, account_id, transaction_id) => ({
        type: actions.BANK_FEED_TRANSACTION_DELETE_REQUEST,
        bank_feed_id,
        account_id,
        transaction_id,
    }),

    bulkDeleteBankFeedTransaction: (bank_feed_id, account_id, transaction_ids) => ({
        type: actions.BANK_FEED_TRANSACTION_BULK_DELETE_REQUEST,
        bank_feed_id,
        account_id,
        request: {
            transaction_ids,
        },
    }),

    performBankFeedSmartRecon: (account_id, start_date, end_date) => ({
        type: actions.BANK_FEED_SMART_RECON_REQUEST,
        request: {
            account_id,
            start_date,
            end_date,
        },
    }),

};

export default actions;
